<template>
  <el-collapse accordion
               v-if="fullNode && fullNode.project_node && fullNode.project_node.msg_result && fullNode.project_node.msg_result.length > 0">
    <el-collapse-item>
      <template slot="title">
        <div style="display: flex; align-items: center; flex: 1;">
          首次填写时间：<b style="margin-right: 5px;">{{ fullNode.project_node.node_finished_time || '-' }}</b>
          最后填写时间：<b>{{ fullNode.project_node.updated_at || '-' }}</b>
          <el-button plain
                     type="primary"
                     size="mini"
                     style="margin-left: auto; margin-right: 15px;"
                     @click="goToSnapshot()">
            查看提交记录
          </el-button>
        </div>
      </template>
      <template v-for="item in fullNode.project_node.msg_result">
        <div>{{ `${item.created_at}: ${item.admin_name}/${item.admin_id} ${item.msg}` }}</div>
      </template>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'HistoryLogCom',
  props: {
    fullNode: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    goToSnapshot () {
      sessionStorage.setItem('snapshot_project_node_id', this.fullNode.project_node.id)
      this.$router.push('/project/progress-node-snapshot')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/project/node-views/HistoryLogCom.vue